/** @jsx jsx */
import { css, jsx } from '@emotion/core'

import { NewsTopics } from '../hooks/useNewsItems'
import { NewsListItem } from './NewsListItem'

type NewsBalancedTopicsSectionProps = {
  topics: NewsTopics
  textFontSize?: number
}

export function NewsBalancedTopicsSection(props: Readonly<NewsBalancedTopicsSectionProps>) {
  const { topics, textFontSize } = props

  return (
    <div css={styles.topicsContainer}>
      {topics.map((value) => (
        <NewsListItem key={`balanced-topic-${value.id}`} fontSize={textFontSize ?? 0.8125}>
          {value.title}
        </NewsListItem>
      ))}
    </div>
  )
}

const styles = {
  topicsContainer: css`
    &:has(li:nth-child(4)) {
      column-count: 2;
      column-gap: 2rem;
    }
  `,
}
